/* globals google, siteMeta, bootstrap */
(function utils() {
    // Globals
    const { ajaxURL, nonce } = siteMeta;
    const NPI_DATA = {};
    const MODAL_CACHE = {
        invalidModalElement: {
            hide: () => console.warn('Bootstrap Modal Element does not exist', 'show()'),
            show: () => console.warn('Bootstrap Modal Element does not exist', 'hide()'),
        },
    };
    let FIRE_COUNT = 0;
    // Initiate a utilities object in the window object to use globally.

    // Error Msgs
    window.ERROR_MSG = {
        EMAIL_EXISTS:           'An account for the specified email address already exists.',
        EMAIL_INVALID:          'Please enter a valid email address.',
        NPI_INVALID:            'Invalid NPI number',
        REQUEST_FAIL:           'There was an error processing your request. Please try again later.',
        PASS_REENTER_NOT_MATCH: 'Password and Re-enter password need to match.',
        PASS_CONFIRM_NOT_MATCH: 'Password and Confirm password need to match',
        PASS_MIN_LENGTH:        'Password must be at least 8 characters long.',
        PASS_ERROR:             '8 characters minimum. Must Include both lower and uppercase letters and numerical characters. Must include at least one special character.',
        ALL_REQUIRED:           'All form fields in the section below are required.',
        REQUIRED_FIELD:         'This field is required.',
        PASS_INCORRECT:         'Incorrect current password.',
        CANNOT_REPEAT:          'You can\'t repeat your active password.',
        RECAPTCHA_FAILED:       'reCAPTCHA verification failed. Please try again.',
    };

    const u = {
        // Global Elements
        els: {
            body:             document.body,
            npiField:         document.querySelector('[name=npi]'),
            understand:       document.querySelector('[name="understand"]'),
            firstName:        document.querySelector('[name=firstName]'),
            lastName:         document.querySelector('[name=lastName]'),
            email:            document.querySelector('[name=email]'),
            password:         document.querySelector('[name=password]'),
            designationField: document.querySelector('[name=professional-designation-field]'),
            officeCityField:  document.querySelector('[name=office-city-field]'),
            officeStateField: document.querySelector('[name=office-state-field]'),
            officePhoneField: document.querySelector('[name=office-phone-number-field]'),
            linkedInField:    document.querySelector('[name=connect-social-linkedin-field]'),
            facebookField:    document.querySelector('[name=connect-social-facebook-field]'),
            footer:           document.querySelector('#site-footer'),
        },

        // Utilities for the window
        qsa:       (selector, context = document) => [...context.querySelectorAll(selector)],
        qs:        (selector, context = document) => context.querySelector(selector),
        testEmail: email => /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i.test(email),

        /**
         * Checks if the string contains special characters.
         * @param {String} str String to check_npi
         * @returns {Boolean} True if the string contains special characters.
         */
        // containsSpecialChars: str => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,30}$/.test(str),
        containsSpecialChars:    str => /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(str),
        checkPasswordComplexity: str => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,30}$/.test(str),

        bootstrapModal: (el, options = {}) => {
            // if el is string convert it to DOM element.
            const element = typeof el === 'string' ? document.querySelector(el) : el;

            // get id or generate a random id.
            const id = element?.id || `modal-${Math.random().toString(36).substr(2, 9)}`;

            // if the modal is already initiated return the cached modal.
            if (element && MODAL_CACHE[id])
                return MODAL_CACHE[id];

            // if el is not a DOM element fail silently but still allow for use of functions such as hide() and show()
            if (!(element instanceof Element)) {
                console.warn('Bootstrap Modal Element does not exist', el);
                return MODAL_CACHE.invalidModalElement;
            }

            MODAL_CACHE[id] = new bootstrap.Modal(element, {
                keyboard: false,
                ...options,
            });
            return MODAL_CACHE[id];
        },

        xuFetch: async (body = {}, successCB, errorCB, finallyCB, options = {}) => {
            console.log('xuFetch', body);
            // if the body is a form element convert it to an object.
            if (body instanceof HTMLFormElement)
                body = Object.fromEntries(new FormData(body).entries());

            const defaults = {
                method: 'POST',
                body:   new URLSearchParams(body),
                ...options,
            };

            const url = defaults.url || ajaxURL;
            delete defaults.url;

            let errorData = null;

            try {
                const res = await fetch(url, defaults);
                if (res.ok) {
                    const data = await res.json();

                    if (!data.success) {
                        errorData = data;
                        throw new Error('Request failed');
                    }

                    successCB && successCB(data);
                    console.log('xuFetch success', data);
                    return;
                }
                throw new Error(`Request failed with status ${res.status}`);
            } catch (error) {
                console.log('catch xuFetch error', errorData || error);
                errorCB && errorCB(errorData || error);
            } finally {
                finallyCB && finallyCB();
            }
        },

        /**
         * Checks if the NPI number is valid.
         * @param {Number} npi NPI number to check
         * @returns {Promise} Promise object represents the fetch request.
         */
        checkNPI: async (npi) => {
            console.log('checkNPI', npi, NPI_DATA);
            // Check if the NPI is already checked.
            if (NPI_DATA[npi] && NPI_DATA[npi]?.data?.number === npi)
                return NPI_DATA[npi].data;

            try {
                const response = await fetch(ajaxURL, {
                    method: 'POST',
                    body:   new URLSearchParams({
                        _wpnonce: nonce.checkNpi,
                        action:   'check_npi',
                        npi,
                    }),
                });

                if (response.ok) {
                    // Set the NPI_DATA
                    NPI_DATA[npi] = await response.json();

                    if (NPI_DATA[npi].success)
                        return NPI_DATA[npi].data;
                    return false;
                }

                throw new Error(`Request failed with status ${response.status}`);
            } catch (error) {
                throw new Error(`Error: ${error.message}`);
            }
        },

        /**
         * Update the submit button text and disabled state.
         * @param {String} state State key to update the button text and disabled state.
         */
        updateSubmitBtn: (state, btn, resetForm = true) => {
            if (!btn || !state) return;
            // Set the default
            if (!btn.dataset.default)
                btn.dataset.default = btn.textContent;

            state = state === '__default__' ? btn.dataset.default : state;
            btn.textContent = state;

            if (state === btn.dataset.default)
                btn.removeAttribute('disabled');
            else
                btn.setAttribute('disabled', true);

            const lowerCaseState = state.toLocaleLowerCase();
            if (lowerCaseState.includes('success') || lowerCaseState.includes('error')) {
                setTimeout(() => u.updateSubmitBtn(btn.dataset.default, btn), 2000);
                resetForm && btn.form?.reset();
            }
        },

        validateRequiredFields: (form) => {
            let valid = true;
            // Remove any previous errors.
            u.qsa('.is-invalid, .is-valid', form).forEach(el => el.classList.remove('is-invalid', 'is-valid'));
            // Check if the required fields are filled.
            u.qsa('.required', form).forEach((el) => {
                const { type, value, checked } = el;
                // text input logic
                if (type === 'checkbox' && !checked)
                    valid = false;
                else if ((type === 'text' || type === 'password') && !value.length)
                    valid = false;

                el.classList.add(valid ? 'is-valid' : 'is-invalid');
            });
            return valid;
        },

        /**
         * Exact functionality of the updateValidatedField.
         * @param {HTML Element} el The element to update.
         * @param {String} theClass Classnames to add to the element.
         * @param {String} message WHat to say
         */
        updateValidatedField: (_el, theClass, message = '') => {
            if (!_el) return false;
            const el =  typeof _el === 'string' ? document.querySelector(_el) : _el;
            el.classList.remove('is-invalid', 'is-valid');
            el.classList.add(theClass);
            if (message.length) {
                const selector = theClass === 'is-invalid' ? '.invalid-feedback' : '.valid-feedback';
                const feedbackEl = el.parentNode.querySelector(selector);
                if (feedbackEl)
                    feedbackEl.innerHTML = message;
            }
            return el;
        },

        populateNPIFields(npiData) {
            // If the data is not valid exits here.
            if (!npiData) return;
            // Deconstruct the data.
            const { basic, addresses } = npiData;
            const { credential, authorized_official_title_or_position: position, first_name: firstName, last_name: lastName, authorized_official_first_name: oFirstName, authorized_official_last_name: oLastName } = basic;
            const { city, state } = addresses[0];
            const phoneNumber = addresses.find(a => a.telephone_number).telephone_number;
            const els = {
                designation: u.qs('#professional-designation-field'),
                officeCity:  u.qs('#office-city-field'),
                officeState: u.qs('#office-state-field'),
                officePhone: u.qs('#office-phone-number-field'),
                firstName:   u.qs('#firstName'),
                lastName:    u.qs('#lastName'),
            };
            const values = {
                designation: credential || position || '',
                officeCity:  city || '',
                officeState: state || '',
                officePhone: phoneNumber || '',
                firstName:   firstName || oFirstName || '',
                lastName:    lastName || oLastName || '',
            };

            // loop through the elements and fill the values.
            Object.entries(els).forEach(([key, el]) => {
                if (el && !el.value) {
                    el.value = values[key];
                    // trigger blur
                    el.dispatchEvent(new Event('blur'));
                }
            });
        },

        /**
         * Load the Google Maps API asynchronously
         * @param {Function} callback
         */
        loadGoogleMapsScript(key, callback) {
            // Check if the script is already loaded.
            if (document.getElementById('google-maps-js')) {
                // run the callback by string
                window[callback]();
                return;
            }
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&callback=${callback}&libraries=geometry,maps,marker`;
            script.id = 'google-maps-js';
            script.defer = true;
            script.async = true;
            document.body.appendChild(script);
        },

        getLatLang(address) {
            const geocoder = new google.maps.Geocoder();
            return geocoder.geocode({ address }, (results, status) => {
                if (status === 'OK') {
                    const { lat, lng } = results[0].geometry.location;
                    return { lat, lng };
                }
            });
        },

        getCurrentBreakpoint: () => getComputedStyle(document.documentElement).getPropertyValue('--breakpoint').trim(),

        generateVCard: (firstName, lastName, address, phoneNumber, email) => {
            let vCard = '';
            vCard += 'BEGIN:VCARD' + '\n';
            vCard += 'VERSION:3.0' + '\n';
            vCard += `FN:${firstName} ${lastName}` + '\n';
            vCard += `N:${lastName};${firstName};;` + '\n';
            vCard += `TEL;TYPE=WORK,VOICE:${phoneNumber}` + '\n';
            vCard += `EMAIL:${email}` + '\n';
            vCard += `ADR;TYPE=WORK,PREF:;;${address}` + '\n';
            vCard += 'END:VCARD';

            const blob = new Blob([vCard], { type: 'text/vcard;charset=utf-8' });
            return window.URL.createObjectURL(blob);
        },

        domReady: (callback) => {
            if (document.readyState === 'loading')
                document.addEventListener('DOMContentLoaded', callback);
            else
                callback();
        },

        isInViewport(element) {
            const rect = element.getBoundingClientRect();
            const elementTop = rect.top + 140;
            const elementBottom = elementTop + element.offsetHeight;
            const viewportTop = window.scrollY || window.pageYOffset;
            const viewportBottom = viewportTop + window.innerHeight;

            return elementBottom > viewportTop && elementTop < viewportBottom;
        },

        /**
         * Check if an element is at the bottom of the viewport.
         * @param {*} el HTML element.
         * @param {number} [offset=0]
         * @returns {boolean} True if the element is at the bottom of the viewport.
         */
        isElementViewport(el, options) {
            const offset = +options?.offset || 0;
            const origin = options?.origin || 'top';
            const elRect = el.getBoundingClientRect();
            const winHeight = window.innerHeight || document.documentElement.clientHeight;

            if (origin === 'top')
                return elRect.top + offset >= winHeight;
            if (origin === 'bottom')
                return elRect.bottom + offset <= winHeight;
            if (origin === 'center')
                return elRect.top + elRect.height / 2 + offset <= winHeight / 2;
            return false;
        },

        formatPhoneNumber(phoneNumber) {
            // Remove all non-digit characters from the phone number
            const cleaned = (`${phoneNumber}`).replace(/\D/g, '');

            // Match the cleaned number to the desired format using regex groups
            const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

            if (match) {
                // Format the phone number using captured groups
                return `(${match[1]}) ${match[2]}-${match[3]}`;
            }

            // Return the original phone number if it doesn't match the desired format
            return phoneNumber;
        },

    };

    window.saveLatLng = () => {
        // Stop after 10 tries.
        if (FIRE_COUNT > 10) return;
        // Run untill the userAddress is set.
        if (window.userAddress === undefined) {
            setTimeout(() => window.saveLatLng(), 10);
            FIRE_COUNT += 1;
            return;
        }
        const { userAddress } = window;
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: userAddress }, async (results, status) => {
            if (status === 'OK') {
                const { lat, lng } = results[0].geometry.location;

                u.xuFetch(
                    { action:     'edit_profile',
                        _wpnonce:   nonce.editUserProfile,
                        office_lat: lat(),
                        office_lng: lng() },
                    () => {
                        // Delete the global variables.
                        delete window.userAddress;
                        FIRE_COUNT = 0;
                    },
                );
            }
        });
    };

    window.utilities = u;
}());
